import resize_handler from './resize_handler';
export default {
        mixins: [resize_handler],
mounted(){
        this.set_prlx();
        if(this.windowWidth >= 768){
        window.addEventListener('scroll', this.set_prlx);
        }
},
beforeDestroy(){
        window.removeEventListener('scroll', this.set_prlx);

},
methods: {
        set_prlx(){
                let Y = window.scrollY;
                for (let ref in this.$refs) {
                        let _parent;
 
             
                       if(this.$refs.banner_parent){

                        _parent = this.$refs.banner_parent;
                        
                       }

                        if(this.$refs[ref].tagName == 'IMG'){
                                let _img = this.$refs[ref];
                                let prlx_val = parseInt(_img.getAttribute('prlx-val'));
                                let scroll_val = this.windowHeight - _parent.getBoundingClientRect().top >= 0 ? this.windowHeight - _parent.getBoundingClientRect().top : 0;
                                let _Y = (scroll_val) / -prlx_val;
               
                                if(_parent.getBoundingClientRect().bottom > 0 && _parent.getBoundingClientRect().top < window.innerHeight){
                                         _img.style.transform = `translateY(${_Y}px)` 

                                } else {
                                        return;
                                }
                          
                       

                        }
                    }
        }
}
}
